import React, { ReactElement } from 'react';

import { Route } from '@philips-emr/hpms-provider-accreditation-commons';
import { Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';

import { NegotiationAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

interface NegotiationData {
  ieStatus: NegotiationStatus,
  dsStatus: string,
  nrSeqNegotiation: number,
}

enum NegotiationStatus {
  AWAITING_ACTION = 1,
  NEGOTIATING = 2,
  CLOSED = 3,
  CANCELED = 4
}

@Controller({ fragment: FragmentNames.NEGOTIATION })
class NegotiationController extends BaseController {

  @OnDynamicContentRender(Aliases.CARD_NEGOTIATION)
  onDynamicContentRenderCardCall(event: RenderEvent): void {
    const { data, render } = event;
    const { ieStatus, dsStatus } = data as NegotiationData;
    const content = (): ReactElement => (getStampByStatus(ieStatus, dsStatus));
    render(content);
  }

  @OnSelectItem(Aliases.DECK_NEGOTIATION)
  onSelectItemBeneficiarios(event: SelectItemEvent<NegotiationData>): void {
    const { nrSeqNegotiation } = event.item;
    this.historyService.push(Route.NEGOTIATION_DETAILS, { nrSeqNegotiation });
  }

}

function getStampByStatus(cdStatus: NegotiationStatus, dsStatus: string): ReactElement {
  return (
    <Stamp icon={getIconTypeByStatus(cdStatus)} color={getIconColorByStatus(cdStatus)} label={dsStatus} />
  );
}

function getIconTypeByStatus(cdStatus: NegotiationStatus): StampIcon {
  const icon = {
    [NegotiationStatus.AWAITING_ACTION]: StampIcon.CLOCK,
    [NegotiationStatus.NEGOTIATING]: StampIcon.CLOCK,
    [NegotiationStatus.CLOSED]: StampIcon.CHECK,
    [NegotiationStatus.CANCELED]: StampIcon.CANCELED,
  };

  return icon[cdStatus];
}

function getIconColorByStatus(cdStatus: NegotiationStatus): Color {
  const color = {
    [NegotiationStatus.AWAITING_ACTION]: Color.SAFETY_NEUTRAL,
    [NegotiationStatus.NEGOTIATING]: Color.SAFETY_BLUE,
    [NegotiationStatus.CLOSED]: Color.SAFETY_GREEN,
    [NegotiationStatus.CANCELED]: Color.SAFETY_RED,
  };
  return color[cdStatus];
}

export {
  NegotiationController,
  NegotiationStatus,
  getStampByStatus,
  NegotiationData,
};
